module.exports = __webpack_public_path__ + "img/bills.733b4046.svg";